import {React} from 'common'
import {Colors, Styles} from 'appearance'
import MuiDrawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import {styled} from '@mui/material/styles'
import SideMenuItem from 'components/Page/SideMenu/SideMenuItem'
import {Box} from '@mui/material'
import {SIDE_MENU_ANIMATION_DURATION} from 'appearance/styles'
import {menuItems, menuItemsSuperAdmin} from 'constants/sideMenu'
import SideMenuHeader from './SideMenu/SideMenuHeader'
import useUserInfo from 'logic/Auth/useUserInfo.js'

const SideMenu = ({open, handleClose}) => {
    const {isSuperAdmin} = useUserInfo()
    return (
        <Box>
            <Drawer
                sx={{display: {xs: 'none', sm: 'flex'}, boxShadow: 3}}
                variant="permanent"
                open={open}
                elevation={50}>
                <SideMenuHeader open={open} handleClose={handleClose} />
                <List>
                    {(isSuperAdmin ? menuItemsSuperAdmin : menuItems).map(
                        (text, index) => (
                            <SideMenuItem
                                key={text}
                                index={index}
                                open={open}
                                text={text}
                            />
                        )
                    )}
                </List>
            </Drawer>
        </Box>
    )
}

export default SideMenu

const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({theme, open}) => ({
    width: Styles.DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
        ...openedSidebar(theme),
        '& .MuiDrawer-paper': openedSidebar(theme),
    }),
    ...(!open && {
        ...closedSidebar(theme),
        '& .MuiDrawer-paper': closedSidebar(theme),
    }),
    '& *': {color: `${Colors.APP_WHITE}`},
}))

const openedSidebar = (theme) => ({
    width: Styles.DRAWER_WIDTH,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: SIDE_MENU_ANIMATION_DURATION,
    }),
    overflowX: 'hidden',
    backgroundColor: Colors.APP_BLACK,
})

const closedSidebar = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: SIDE_MENU_ANIMATION_DURATION,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
    backgroundColor: Colors.APP_BLACK,
})
